<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="languagesMenu"
    class="dark:text-[#E9EDEF] text-[#1e293b]"
>
    <mat-icon
        class="icon-size-5"
        [svgIcon]="'heroicons_outline:language'"
    ></mat-icon>
</button>

<!-- Language menu -->
<mat-menu
    [xPosition]="'before'"
    #languagesMenu="matMenu"
    class="dark:bg-[#233138] bg-white"
>
    @for (lang of availableLangs; track lang.id) {
        <button
            mat-menu-item
            [ngClass]="{
                'dark:text-[#E9EDEF] text-[#1e293b]': true,
                'dark:bg-[#182229] bg-[#f8fafc]': lang.id === currentLang,
                'hover:dark:bg-[#182229] hover:bg-[#f8fafc]': lang.id !== currentLang
            }"
            (click)="setActiveLang(lang.id)"
        >
            <span class="flex items-center">
                <span
                    class="flex items-center justify-center mr-3"
                >
                    <img style="border-radius: 0"
                        class="mt-0"
                        [src]="lang.flag"
                        alt="language flag"
                    />
                </span>
                <span>{{ lang.title }}</span>
            </span>
        </button>
    }
</mat-menu>

<!-- Flag image template -->
<ng-template let-lang #flagImage>
    <span class="relative w-6 overflow-hidden rounded-sm shadow">
        <span
            class="absolute inset-0 ring-1 ring-inset dark:ring-white dark:ring-opacity-10 ring-black ring-opacity-10"
        ></span>
        <img
            class="w-full"
            [src]="'images/flags/' + flagCodes[lang].toUpperCase() + '.svg'"
            [alt]="'Flag image for ' + lang"
        />
    </span>
</ng-template>
